// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function useCustomPaymentMethodConfigs(paymentMethod, paymentMethodType) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var paymentMethodsConfig = match.paymentMethodsConfig;
  var allowedPmTypeForCardPayment = [
    "debit",
    "credit"
  ];
  return React.useMemo((function () {
                var methodLevelConfig = paymentMethodsConfig.find(function (config) {
                      return config.paymentMethod === paymentMethod;
                    });
                var methodLevelMessage = Core__Option.getOr(Core__Option.map(methodLevelConfig, (function (config) {
                            return config.message;
                          })), PaymentType$OrcaPaymentPage.defaultPaymentMethodMessage);
                if (paymentMethodType === undefined) {
                  return methodLevelMessage;
                }
                var typeLevelMessage = Core__Option.flatMap(methodLevelConfig, (function (config) {
                        return Core__Option.map(config.paymentMethodTypes.filter(function (pmTypeConfig) {
                                          if (paymentMethod === "card") {
                                            return allowedPmTypeForCardPayment.includes(pmTypeConfig.paymentMethodType);
                                          } else {
                                            return pmTypeConfig.paymentMethodType === paymentMethodType;
                                          }
                                        })[0], (function (pmTypeConfig) {
                                      return pmTypeConfig.message;
                                    }));
                      }));
                return Core__Option.getOr(typeLevelMessage, methodLevelMessage);
              }), [
              paymentMethod,
              paymentMethodType,
              paymentMethodsConfig
            ]);
}

export {
  useCustomPaymentMethodConfigs ,
}
/* react Not a pure module */
